<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    title="Wprowadź dane faktury"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <w-input class="col-md-12 form-group" :model="$schema.number" />

      <w-input class="col-md-12 form-group" :model="$schema.price" />

      <w-input class="col-md-12 form-group" :model="$schema.priceToPay" />

      <w-warnings :model="$schema" />
    </div>
  </w-modal>
</template>

<script>
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/invoice.schema';

const emptyData = () => ({
  number: '',
  price: null,
  priceToPay: null
});

// @vuese
// Modal faktury
// @group Document
export default {
  mixins: [manageMixin('invoice', {}, emptyData)],
  schema,
  props: {
    // Maksymalna kwota do wypłaty
    maxToPay: { type: Number, default: 0 }
  },

  watch: {
    maxToPay(maxToPay) {
      this.refreshMaxToPay(maxToPay);
    }
  },
  mounted() {
    this.refreshMaxToPay(this.maxToPay);
  },

  methods: {
    // @vuese
    // Odświeża maksymalną kwotę do wypłaty
    refreshMaxToPay(maxToPay) {
      this.$options.external = { maxToPay };
      this.$setSchema(schema);
    }
  }
};
</script>
